import { render, staticRenderFns } from "./customize-home.vue?vue&type=template&id=4c31b1e9"
import script from "./customize-home.vue?vue&type=script&lang=ts"
export * from "./customize-home.vue?vue&type=script&lang=ts"
import style0 from "./customize-home.vue?vue&type=style&index=0&id=4c31b1e9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports